import { AxiosPromise } from 'axios';
import httpClient from '../../common/api/httpClient';
import urlRoute from '../../common/service/urlRoute';
import { API } from '../constants/api';
import IStockListRequestPayload from '../model/IStockListRequestPayload';
import IStockListResponse from '../model/IStockListResponse';
import IStockValidateRequestPayload from '../model/validate/IStockValidateRequestPayload';
import IStockValidateResponse from '../model/validate/IStockValidateResponse';

const stockApi = {
  list: (payload: IStockListRequestPayload): AxiosPromise<IStockListResponse> => {
    return httpClient.post(urlRoute.createUrl(API.STOCK_LIST_PATH), payload);
  },
  validateSelections: (payload: IStockValidateRequestPayload): AxiosPromise<IStockValidateResponse> => {
    return httpClient.post(urlRoute.createUrl(API.STOCK_VALIDATE_SELECTIONS), payload);
  },
};

export default stockApi;
